export default __webpack_public_path__ + "static/media/kub.822fba70.jpg";